import type { SupportedLocale } from '@/lib/utils/localization/getFlattenedLocales'
import { logError } from '../utils/shared/log'
import { getCosmicHeader } from './cosmic/fetchFunctions/getCosmicHeader'
import type { CMSError, CMSResult } from './types/CMSError'

export type GetHeaderDataProps = {
  locale: SupportedLocale
}

export const getHeaderData = async ({
  locale,
}: GetHeaderDataProps): Promise<
  CMSResult<ReturnType<typeof getCosmicHeader>>
> => {
  try {
    const cosmicHeader = await getCosmicHeader({ locale })

    if (!cosmicHeader) {
      const errorDetails: CMSError = {
        code: 'COSMIC_HEADER_DATA_MISSING',
        message:
          'Some navigation elements are temporarily unavailable. Please refresh the page.',
        source: 'cosmic',
        timestamp: new Date().toISOString(),
      }

      return {
        error: errorDetails,
      }
    }

    return cosmicHeader
  } catch {
    const errorDetails: CMSError = {
      code: 'COSMIC_HEADER_FETCH_FAILED',
      message:
        "We're having trouble loading the navigation menu. Please try refreshing the page.",
      source: 'cosmic' as const,
      timestamp: new Date().toISOString(),
    }

    logError('COSMIC: Error fetching cosmic header data:', errorDetails)
    return { error: errorDetails }
  }
}
